import { request } from '@reflex/ui/client/http';
import type { Agent } from '@reflex/shared';
import type {
  AgentPersona,
  CreateAgentPersona,
  LaunchFromPersona,
  UpdateAgentPersona,
} from '../shared/types.js';

export const agentPersonaApi = {
  listPersonas: () => request<AgentPersona[]>('/agent-personas'),
  getPersona: (id: string) => request<AgentPersona>(`/agent-personas/${encodeURIComponent(id)}`),
  createPersona: (data: CreateAgentPersona) =>
    request<AgentPersona>('/agent-personas', { method: 'POST', body: JSON.stringify(data) }),
  updatePersona: (id: string, data: UpdateAgentPersona) =>
    request<AgentPersona>(`/agent-personas/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  deletePersona: (id: string) =>
    request<{ ok: boolean }>(`/agent-personas/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  launchPersona: (id: string, body: LaunchFromPersona) =>
    request<Agent>(`/agent-personas/${encodeURIComponent(id)}/launch`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
